import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CopyModuleMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  duplicateChildContent: Types.Scalars['Boolean']['input'];
}>;


export type CopyModuleMutation = { __typename?: 'Mutation', copyModule: { __typename?: 'ModuleMutationResult', success: boolean, module?: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string } } | null, error?: { __typename?: 'Error', code: string } | null } };


export const CopyModuleDocument = gql`
    mutation CopyModule($id: Int!, $duplicateChildContent: Boolean!) {
  copyModule(id: $id, duplicateChildContent: $duplicateChildContent) {
    success
    module {
      id
      libraryItem {
        id
      }
    }
    error {
      code
    }
  }
}
    `;
export type CopyModuleMutationFn = Apollo.MutationFunction<CopyModuleMutation, CopyModuleMutationVariables>;

/**
 * __useCopyModuleMutation__
 *
 * To run a mutation, you first call `useCopyModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyModuleMutation, { data, loading, error }] = useCopyModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duplicateChildContent: // value for 'duplicateChildContent'
 *   },
 * });
 */
export function useCopyModuleMutation(baseOptions?: Apollo.MutationHookOptions<CopyModuleMutation, CopyModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyModuleMutation, CopyModuleMutationVariables>(CopyModuleDocument, options);
      }
export type CopyModuleMutationHookResult = ReturnType<typeof useCopyModuleMutation>;
export type CopyModuleMutationResult = Apollo.MutationResult<CopyModuleMutation>;
export type CopyModuleMutationOptions = Apollo.BaseMutationOptions<CopyModuleMutation, CopyModuleMutationVariables>;